module.exports = __webpack_public_path__ + "static/img/pc02.98259e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/1yuan/pc02.png
// module id = a/jZ
// module chunks = 1